'use strict';

angular.module('clientDashboardApp').controller("UpdateAccountCtrl", function ($scope, $location, userService, userManagerService) {
    $scope.profile = {};
    angular.copy($scope.userInfo, $scope.profile);
    $scope.pendingResponse = false;
    $scope.formSubmitted = false;

    $scope.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || $scope.formSubmitted);
    };

    $scope.openResetPasswordModal = function () {
      $scope.passwordResetState = "Editing";
      $scope.passwordModalCloseText = "Cancel";
      $scope.user.password = '';
      $scope.user.confirmPassword = '';

      $('#resetPasswordModal').modal();
    };

    $scope.updatePassword = function () {
      userManagerService.getUser($scope.userInfo.userId).then(function(userResp){
        var currentUser = userResp.data;
        currentUser.password = $scope.user.password;
        $scope.passwordResetState = "Updating";
        userManagerService.updateUserPassword(currentUser).then(function(){
          $scope.passwordResetState = "Success";
          $scope.passwordModalCloseText = "Close";
        }, function(){
          $scope.passwordResetState = "Error";
          $scope.passwordModalCloseText = "Close";
        });
      })
    };

    $scope.updateUser = function(profile) {
        $scope.pendingResponse = true;
        $scope.formSubmitted = true;
        userService.updateUser(profile).then(function() {
            userService.currentUser(true).then(function (userInfo) {
                $scope.userInfo = userInfo;
                $location.url('/user/account');
                $scope.pendingResponse = false;
            });
        });
    }

    $scope.cancel = function(){
      $location.path('/user/account');
    }


});
